import { RoutingHelper } from '../../../helpers/injector.helper';
import { WorkflowType } from '../../../models/enums/workflowtype.enum';
import { WorkflowModuleExecuter, WorkflowStatus } from '../../../models/workflow/workflow.model';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../services/workflow.service';

export class NavigateToForgotPWSettingsData {
}

export class NavigateToForgotPWSettingsDataHelper extends WorkflowModuleSettingsHelper {
    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'navigateToForgotPWModule';
        reg.Caption = '@@Navigiere zu Passwort vergessen';
        reg.GroupID = 'wfActions';
        reg.Index = 112;
        reg.SettingsTypeHelper = new NavigateToForgotPWSettingsDataHelper();
        reg.Executer = NavigateToForgotPWModuleExecuter;
        reg.WorkflowType = WorkflowType.Client;
        return reg;
    }

    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [];
    }

    getEmptySettingsInstance() {
        return new NavigateToForgotPWSettingsData();
    }
}

export class NavigateToForgotPWModuleExecuter extends WorkflowModuleExecuter {
    async execute(status: WorkflowStatus): Promise<number> {
        RoutingHelper.Router.navigate([], {
            queryParams: {
                forgotPW: 0
            }
        });
        return 0;
    }
}